export const config = process.env.VUE_APP_ENV === 'live' ? require('./live').config
	: process.env.VUE_APP_ENV === 'test' ? require('./test').config
		: require('./dev').config
